import { documentBuilderConstants as constants } from '../_constants/document-builder.constants';
import { List } from 'immutable';

const pageBreak = { position: null, type: 'page_break' };
const header = { position: null, type: 'header', bold: true, fontSize: "small", text: 'Enter your header' };
const question = { position: null, type: 'question', linkId: null };
const firstName = { position: null, type: 'first_name' };
const lastName = { position: null, type: 'last_name' };
const dateOfBirth = { position: null, type: 'date_of_birth' };
const gender = { position: null, type: 'gender' };
const height = { position: null, type: 'height' };
const weight = { position: null, type: 'weight' };
const race = { position: null, type: 'race' };
const ethnicity = { position: null, type: 'ethnicity' };
const preferredLanguage = { position: null, type: 'preferred_language' };
const allergies = { position: null, type: 'allergies' };
const medications = { position: null, type: 'medications' };
const treatmentPlan = { position: null, type: 'treatment_plan' };
const physicalExam = { position: null, type: 'physical_exam' };
const studiesImaging = { position: null, type: 'studies_imaging' };
const dialogue = { position: null, type: 'dialogue' };
const hpi = { position: null, type: 'hpi' };
const diagnosis = { position: null, type: 'diagnosis' };
const appointmentDetails = { position: null, type: 'appointment_details' };

function factory(data) {
  switch (data.type) {
    case 'page_break':
      return pageBreak;
    case 'header':
      return header;
    case 'question':
      return Object.assign(question, { linkId: data.question.linkId });
    case 'first_name':
      return firstName;
    case 'last_name':
      return lastName;
    case 'date_of_birth':
      return dateOfBirth;
    case 'gender':
      return gender;
    case 'height':
      return height;
    case 'weight':
      return weight;
    case 'race':
      return race;
    case 'ethnicity':
      return ethnicity;
    case 'preferred_language':
      return preferredLanguage;
    case 'allergies':
      return allergies;
    case 'medications':
      return medications;
    case 'treatment_plan':
      return treatmentPlan;
    case 'physical_exam':
      return physicalExam;
    case 'studies_imaging':
      return studiesImaging;
    case 'dialogue':
      return dialogue;
    case 'diagnosis':
      return diagnosis;
    case 'hpi':
      return hpi;
    case 'appointment_details':
      return appointmentDetails;
    default:
      return false;
  }
}

export const initialState = {
  editQuestion: false,
  current: {
    item: []
  }
}

export function documentBuilder(state = initialState, action) {
  if (action.type === constants.DOCUMENT_DECREMENT_LINKID) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map(function (item) {
          const indexLinkId = parseInt(item.linkId) - 1;

          const from = action.from + 1;

          if (from.toString() === item.linkId) {
            const to = action.to + 1;

            return {
              ...item,
              linkId: to.toString()
            }
          } else if (indexLinkId >= action.from && indexLinkId <= action.to) {
            const newLinkId = parseInt(item.linkId) - 1;

            return {
              ...item,
              linkId: newLinkId.toString()
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_INCREMENT_LINKID) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map(function (item) {
          const linkId = parseInt(item.linkId) - 1;
          const from = action.from + 1;

          if (from.toString() === item.linkId) {
            const to = action.to + 1;

            return {
              ...item,
              linkId: to.toString()
            }
          } else if (linkId >= action.to && linkId <= action.from) {
            const newLinkId = parseInt(item.linkId) + 1;

            return {
              ...item,
              linkId: newLinkId.toString()
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_GET_SUCCESS) {
    return {
      ...state,
      current: action.document
    }
  }

  if (action.type === constants.DOCUMENT_RESET) {
    return initialState;
  }

  if (action.type === constants.DOCUMENT_RESET_IDS) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item, i) => {
          return { ...item, position: (i + 1).toString() }
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_REARRANGE_ITEMS) {
    const itemsCopy = List(state.current.item);
    const movingItem = itemsCopy.get(action.from);
    const arranged = itemsCopy.splice(action.from, 1)
      .splice(action.to, 0, movingItem);

    return {
      ...state,
      editQuestion: false,
      current: {
        ...state.current,
        item: arranged.toArray()
      }
    }
  }

  if (action.type === constants.DOCUMENT_BUILDER_SET_EDIT_QUESTION) {
    return {
      ...state,
      editQuestion: action.item.position
    }
  }

  if (action.type === constants.DOCUMENT_BUILDER_SET_FONT_SIZE) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (state.editQuestion === item.position) {
            return {
              ...item,
              fontSize: action.size
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_ONLY_ANSWER) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (state.editQuestion === item.position) {
            return {
              ...item,
              onlyAnswer: action.value
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_BUILDER_SET_BOLD) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (state.editQuestion === item.position) {
            return {
              ...item,
              bold: action.bold
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_BUILDER_SET_HEADER_TEXT) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (state.editQuestion === item.position) {
            return {
              ...item,
              text: action.text
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_REMOVE_QUESTION) {
    return {
      ...state,
      editQuestion: false,
      current: {
        ...state.current,
        item: state.current.item.filter((item) => {
          return item.type !== 'question' || (item.type === 'question' && item.linkId !== action.item.linkId);
        }).map((item, i) => {
          if (parseInt(item.linkId) > parseInt(action.item.linkId)) {
            const newLinkId = parseInt(item.linkId) - 1;

            return {
              ...item,
              linkId: newLinkId.toString(),
              position: (i + 1).toString()
            }
          }


          return { ...item, position: (i + 1).toString() }
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_BUILDER_REMOVE_DATA) {
    const editQuestion = state.editQuestion;

    return {
      ...state,
      editQuestion: false,
      current: {
        ...state.current,
        item: state.current.item.filter((item) => {
          return item.position !== editQuestion
        }).map((item, i) => {
          return { ...item, position: (i + 1).toString() }
        })
      }
    }
  }

  if (action.type === constants.DOCUMENT_BUILDER_ADD_DATA) {
    const position = state.current.item.length + 1;

    return {
      ...state,
      editQuestion: position,
      current: {
        ...state.current,
        item: [
          ...state.current.item,
          Object.assign({}, factory(action.data), { position })
        ]
      }
    }
  }

  return state;
}